import React from 'react';
import {Button, Typography} from 'onboarding-components';
import moment from 'moment';

import {SetupGuideContext} from 'common/onboarding/immersive-onboarding/types';
import {SvgIconReact} from 'common/components/svg-icon';
import {IMMERSIVE_ASSETS} from 'common/onboarding/immersive-onboarding/assets';

import styles from './summary-table.module.styl';

export const SummaryTable: React.FC<{onEdit: () => void; tableTitle?: string}> = ({onEdit, tableTitle}) => {
  const {setupGuideInfo} = React.useContext(SetupGuideContext);
  const {eventsPropertiesMap} = setupGuideInfo;

  return (
    <table className={styles.container}>
      <thead>
        <tr
          className={styles.tableHeader}
          style={{
            backgroundImage: `url(${IMMERSIVE_ASSETS.tableHeaderGradient})`,
            backgroundSize: `cover`,
            backgroundRepeat: `no-repeat`,
          }}
        >
          <th className={styles.tableTitleSection}>
            <div className={styles.tableTitle}>
              <img className={styles.moniker} src={IMMERSIVE_ASSETS.summaryCheckmark} />
              <Typography variant='headingXs' className={styles.noMargin}>
                {tableTitle ? tableTitle : `Your team's planned events`}
              </Typography>
            </div>
            <Typography className={styles.tableSubtitle} variant='captionSm'>
              Edited by
              <Typography className={styles.boldText} variant='captionSm' weight='bold'>
                {` `}
                {setupGuideInfo?.author || setupGuideInfo?.email}
                {` `}
              </Typography>
              on{` `}
              {setupGuideInfo?.modified ? moment(setupGuideInfo.modified).format(`MMM D, YYYY`) : ``}
            </Typography>
          </th>
          <th>
            <Button variant='inline' includeArrow={false} onClick={onEdit}>
              Edit
            </Button>
          </th>
        </tr>
      </thead>
      <tbody className={styles.tableBody}>
        <tr className={styles.tableHeaderRow}>
          <td className={styles.event}>
            <Typography variant='captionSm' weight='bold'>
              Event
            </Typography>
          </td>
          <td className={styles.properties}>
            <Typography variant='captionSm' weight='bold'>
              Properties
            </Typography>
          </td>
        </tr>
        {Object.keys(eventsPropertiesMap).map((event, index) => {
          const properties = eventsPropertiesMap[event];
          return (
            <tr key={`${event}-row-${index}`} className={styles.tableRow}>
              <td className={styles.event}>
                <div className={styles.moniker}>
                  <SvgIconReact icon='event' />
                </div>
                <Typography variant='captionSm' weight='bold'>
                  {event}
                </Typography>
              </td>
              <td className={styles.properties}>
                <Typography variant='captionSm'>{properties.join(`, `)}</Typography>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
